var map = {
	"./1": 144,
	"./1.png": 144,
	"./2": 145,
	"./2.png": 145,
	"./3": 146,
	"./3.png": 146,
	"./4": 147,
	"./4.png": 147,
	"./about": 148,
	"./about.png": 148,
	"./activity": 248,
	"./activity.svg": 248,
	"./add-cta": 330,
	"./add-cta-active": 331,
	"./add-cta-active.svg": 331,
	"./add-cta.svg": 330,
	"./added-to-collections-active": 332,
	"./added-to-collections-active.svg": 332,
	"./adobe": 149,
	"./adobe.png": 149,
	"./analytics": 333,
	"./analytics.svg": 333,
	"./annotate": 334,
	"./annotate-active": 335,
	"./annotate-active.svg": 335,
	"./annotate.svg": 334,
	"./annotate/arrow": 291,
	"./annotate/arrow.svg": 291,
	"./annotate/crop": 292,
	"./annotate/crop.svg": 292,
	"./annotate/draw": 293,
	"./annotate/draw.svg": 293,
	"./annotate/ellipse": 294,
	"./annotate/ellipse-focus": 295,
	"./annotate/ellipse-focus.svg": 295,
	"./annotate/ellipse.svg": 294,
	"./annotate/emoji": 129,
	"./annotate/emoji.png": 129,
	"./annotate/emoji@2x": 130,
	"./annotate/emoji@2x.png": 130,
	"./annotate/emoji@3x": 131,
	"./annotate/emoji@3x.png": 131,
	"./annotate/highlighter": 296,
	"./annotate/highlighter.svg": 296,
	"./annotate/line": 297,
	"./annotate/line.svg": 297,
	"./annotate/number": 298,
	"./annotate/number.svg": 298,
	"./annotate/pixelate": 299,
	"./annotate/pixelate.svg": 299,
	"./annotate/rect": 300,
	"./annotate/rect.svg": 300,
	"./annotate/square-focus": 301,
	"./annotate/square-focus.svg": 301,
	"./annotate/text": 302,
	"./annotate/text.svg": 302,
	"./annotate/tools-history-back": 303,
	"./annotate/tools-history-back-disabled": 304,
	"./annotate/tools-history-back-disabled.svg": 304,
	"./annotate/tools-history-back.svg": 303,
	"./annotate/tools-history-forward": 305,
	"./annotate/tools-history-forward-disabled": 306,
	"./annotate/tools-history-forward-disabled.svg": 306,
	"./annotate/tools-history-forward.svg": 305,
	"./annotate/tools-zoom-zoom-in": 287,
	"./annotate/tools-zoom-zoom-in.svg": 287,
	"./annotate/tools-zoom-zoom-out": 288,
	"./annotate/tools-zoom-zoom-out.svg": 288,
	"./app-icon": 336,
	"./app-icon.svg": 336,
	"./apple": 337,
	"./apple.svg": 337,
	"./apple_logo": 234,
	"./apple_logo.svg": 234,
	"./arrow-big": 150,
	"./arrow-big.png": 150,
	"./atlassian": 151,
	"./atlassian.png": 151,
	"./bg-bottom": 152,
	"./bg-bottom.png": 152,
	"./bg-top": 153,
	"./bg-top.png": 153,
	"./bill": 338,
	"./bill.svg": 338,
	"./blurred-drop": 97,
	"./blurred-drop.png": 97,
	"./branding": 289,
	"./branding.svg": 289,
	"./buttons-add-new-collection-hover": 339,
	"./buttons-add-new-collection-hover.svg": 339,
	"./buttons-add-new-collection-sidebar": 340,
	"./buttons-add-new-collection-sidebar.svg": 340,
	"./card-generic": 119,
	"./card-generic.png": 119,
	"./check-mark": 341,
	"./check-mark.svg": 341,
	"./checkmark": 342,
	"./checkmark.svg": 342,
	"./checkmark@2x": 154,
	"./checkmark@2x.png": 154,
	"./chrome": 343,
	"./chrome.svg": 343,
	"./close": 309,
	"./close.svg": 309,
	"./cloud-loader": 271,
	"./cloud-loader.gif": 271,
	"./cloudapp": 155,
	"./cloudapp-favicon": 156,
	"./cloudapp-favicon.png": 156,
	"./cloudapp-icon": 157,
	"./cloudapp-icon.png": 157,
	"./cloudapp-logo-horizontal": 224,
	"./cloudapp-logo-horizontal.svg": 224,
	"./cloudapp.png": 155,
	"./coach-mark": 344,
	"./coach-mark.svg": 344,
	"./collection": 225,
	"./collection.svg": 225,
	"./conversation": 345,
	"./conversation.svg": 345,
	"./dashboard": 249,
	"./dashboard.svg": 249,
	"./download-arrow": 346,
	"./download-arrow.svg": 346,
	"./download-chrome": 347,
	"./download-chrome.svg": 347,
	"./download-cloud": 348,
	"./download-cloud.svg": 348,
	"./download-drop": 349,
	"./download-drop.svg": 349,
	"./download-mac": 350,
	"./download-mac.svg": 350,
	"./download-windows": 351,
	"./download-windows.svg": 351,
	"./download_icon_chrome": 352,
	"./download_icon_chrome.svg": 352,
	"./download_icon_mac": 353,
	"./download_icon_mac.svg": 353,
	"./download_icon_windows": 354,
	"./download_icon_windows.svg": 354,
	"./email": 235,
	"./email.svg": 235,
	"./enterprise@2x": 158,
	"./enterprise@2x.png": 158,
	"./file-placeholder": 307,
	"./file-placeholder.svg": 307,
	"./free@2x": 159,
	"./free@2x.png": 159,
	"./free_plan_icon": 160,
	"./free_plan_icon.png": 160,
	"./gift": 272,
	"./gift.svg": 272,
	"./google_logo": 236,
	"./google_logo.svg": 236,
	"./hat-icon": 355,
	"./hat-icon.svg": 355,
	"./hero-asset": 98,
	"./hero-asset.gif": 544,
	"./hero-asset.png": 98,
	"./icon-clock": 237,
	"./icon-clock.jpeg": 237,
	"./icon-get-cloudapp": 202,
	"./icon-get-cloudapp.svg": 202,
	"./icon-google": 356,
	"./icon-google.svg": 356,
	"./icon-muted": 308,
	"./icon-muted.svg": 308,
	"./icon-muted@2x": 161,
	"./icon-muted@2x.png": 161,
	"./icon-padlock": 203,
	"./icon-padlock.svg": 203,
	"./icons-add": 273,
	"./icons-add-bordered": 162,
	"./icons-add-bordered.png": 162,
	"./icons-add-to-collection-solid": 357,
	"./icons-add-to-collection-solid.svg": 357,
	"./icons-add.svg": 273,
	"./icons-announcement": 358,
	"./icons-announcement.svg": 358,
	"./icons-bug": 359,
	"./icons-bug.svg": 359,
	"./icons-card-actions-compact-read-only": 120,
	"./icons-card-actions-compact-read-only.svg": 120,
	"./icons-clipboard": 258,
	"./icons-clipboard.svg": 258,
	"./icons-close": 286,
	"./icons-close.svg": 286,
	"./icons-conversation": 126,
	"./icons-conversation.svg": 126,
	"./icons-download-bordered": 163,
	"./icons-download-bordered.png": 163,
	"./icons-download-solid": 360,
	"./icons-download-solid.svg": 360,
	"./icons-edit-minimal": 238,
	"./icons-edit-minimal.svg": 238,
	"./icons-embed-bordered": 164,
	"./icons-embed-bordered.png": 164,
	"./icons-embed-solid": 361,
	"./icons-embed-solid.svg": 361,
	"./icons-hidden": 362,
	"./icons-hidden.svg": 362,
	"./icons-invite-active": 250,
	"./icons-invite-active.svg": 250,
	"./icons-invite-default": 251,
	"./icons-invite-default.svg": 251,
	"./icons-locked-bordered": 165,
	"./icons-locked-bordered.png": 165,
	"./icons-magic": 363,
	"./icons-magic.svg": 363,
	"./icons-mouse-click": 364,
	"./icons-mouse-click-gray": 365,
	"./icons-mouse-click-gray.svg": 365,
	"./icons-mouse-click.svg": 364,
	"./icons-new": 166,
	"./icons-new-gray": 274,
	"./icons-new-gray.svg": 274,
	"./icons-new-transparent": 275,
	"./icons-new-transparent.svg": 275,
	"./icons-new-white": 276,
	"./icons-new-white.svg": 276,
	"./icons-new.svg": 166,
	"./icons-notifications": 127,
	"./icons-notifications-active": 128,
	"./icons-notifications-active.svg": 128,
	"./icons-notifications.svg": 127,
	"./icons-premium-star": 277,
	"./icons-premium-star.svg": 277,
	"./icons-rainbow-circle": 167,
	"./icons-rainbow-circle.png": 167,
	"./icons-rounded-corners": 366,
	"./icons-rounded-corners.svg": 366,
	"./icons-sales": 367,
	"./icons-sales.svg": 367,
	"./icons-search": 368,
	"./icons-search.svg": 368,
	"./icons-settings-blue": 278,
	"./icons-settings-blue.svg": 278,
	"./icons-settings-gray": 239,
	"./icons-settings-gray.svg": 239,
	"./icons-share-settings-locked": 369,
	"./icons-share-settings-locked.svg": 369,
	"./icons-slightly-rounded-corners": 370,
	"./icons-slightly-rounded-corners.svg": 370,
	"./icons-square-corners": 371,
	"./icons-square-corners.svg": 371,
	"./icons-support": 372,
	"./icons-support.svg": 372,
	"./icons-toggle-close": 279,
	"./icons-toggle-close.svg": 279,
	"./icons-toggle-open": 280,
	"./icons-toggle-open.svg": 280,
	"./icons-transcribe": 240,
	"./icons-transcribe.svg": 240,
	"./illustrations-transcription-processing": 281,
	"./illustrations-transcription-processing.svg": 281,
	"./indicator-right": 373,
	"./indicator-right.svg": 373,
	"./infinite": 290,
	"./infinite.svg": 290,
	"./installer": 374,
	"./installer.svg": 374,
	"./logo-visa": 375,
	"./logo-visa.jpeg": 375,
	"./logo@2x": 88,
	"./logo@2x-blue": 168,
	"./logo@2x-blue.png": 168,
	"./logo@2x.png": 88,
	"./logos-cloud-app-logomark-full-color": 241,
	"./logos-cloud-app-logomark-full-color.svg": 241,
	"./main-banner": 169,
	"./main-banner.png": 169,
	"./menu-bar": 376,
	"./menu-bar.svg": 376,
	"./onboarding/apple": 204,
	"./onboarding/apple.svg": 204,
	"./onboarding/bill": 170,
	"./onboarding/bill.svg": 170,
	"./onboarding/chrome": 205,
	"./onboarding/chrome.svg": 205,
	"./onboarding/download-arrow": 206,
	"./onboarding/download-arrow.svg": 206,
	"./onboarding/download-chrome": 207,
	"./onboarding/download-chrome.svg": 207,
	"./onboarding/download-drop": 208,
	"./onboarding/download-drop.svg": 208,
	"./onboarding/download-mac": 209,
	"./onboarding/download-mac.svg": 209,
	"./onboarding/download-windows_color": 210,
	"./onboarding/download-windows_color.svg": 210,
	"./onboarding/email": 171,
	"./onboarding/email.svg": 171,
	"./onboarding/hat-icon": 211,
	"./onboarding/hat-icon.svg": 211,
	"./onboarding/icons-check": 121,
	"./onboarding/icons-check.svg": 121,
	"./onboarding/icons-chrome": 212,
	"./onboarding/icons-chrome.svg": 212,
	"./onboarding/icons-download": 172,
	"./onboarding/icons-download.svg": 172,
	"./onboarding/icons-extension": 173,
	"./onboarding/icons-extension.svg": 173,
	"./onboarding/icons-mac-os-app": 106,
	"./onboarding/icons-mac-os-app.png": 106,
	"./onboarding/icons-record": 174,
	"./onboarding/icons-record.svg": 174,
	"./onboarding/in-browser-icon": 213,
	"./onboarding/in-browser-icon.svg": 213,
	"./onboarding/installer": 214,
	"./onboarding/installer.svg": 214,
	"./onboarding/menu-bar": 215,
	"./onboarding/menu-bar.svg": 215,
	"./onboarding/start": 175,
	"./onboarding/start.svg": 175,
	"./onboarding/windows": 216,
	"./onboarding/windows.svg": 216,
	"./parallax": 377,
	"./parallax.jpg": 377,
	"./pattern": 176,
	"./pattern-2": 177,
	"./pattern-2.png": 177,
	"./pattern-4": 178,
	"./pattern-4.png": 178,
	"./pattern.png": 176,
	"./plus": 378,
	"./plus-small": 379,
	"./plus-small.svg": 379,
	"./plus.svg": 378,
	"./prize": 380,
	"./prize.svg": 380,
	"./prize@2x": 110,
	"./prize@2x.png": 110,
	"./pro-badge": 217,
	"./pro-badge.svg": 217,
	"./pro-ribbon": 87,
	"./pro-ribbon.png": 87,
	"./pro-ribbon.svg": 545,
	"./pro@1x": 179,
	"./pro@1x.png": 179,
	"./pro@2x": 122,
	"./pro@2x.png": 122,
	"./pro@3x": 180,
	"./pro@3x.png": 180,
	"./pro_plan_icon": 181,
	"./pro_plan_icon.png": 181,
	"./salesforce": 182,
	"./salesforce.png": 182,
	"./seats-left": 381,
	"./seats-left.svg": 381,
	"./slack-icon": 183,
	"./slack-icon.png": 183,
	"./slack_logo": 382,
	"./slack_logo.svg": 382,
	"./social-proof-image": 242,
	"./social-proof-image.jpeg": 242,
	"./spinner": 65,
	"./spinner.svg": 65,
	"./star_active": 383,
	"./star_active.svg": 383,
	"./star_default": 384,
	"./star_default.svg": 384,
	"./star_hover": 385,
	"./star_hover.svg": 385,
	"./start": 386,
	"./start.svg": 386,
	"./team": 243,
	"./team-3": 387,
	"./team-3.jpg": 387,
	"./team.svg": 243,
	"./team@2x": 123,
	"./team@2x.png": 123,
	"./team_plan_icon": 132,
	"./team_plan_icon.png": 132,
	"./team_sidebar": 184,
	"./team_sidebar.png": 184,
	"./thumbnail": 185,
	"./thumbnail.png": 185,
	"./upload-arrow": 388,
	"./upload-arrow.svg": 388,
	"./upload-cloud": 389,
	"./upload-cloud.svg": 389,
	"./upload-copy": 186,
	"./upload-copy.png": 186,
	"./upload-copy@2x": 187,
	"./upload-copy@2x.png": 187,
	"./upload-copy@3x": 188,
	"./upload-copy@3x.png": 188,
	"./upload-drop": 390,
	"./upload-drop.svg": 390,
	"./video-thumbnail": 189,
	"./video-thumbnail.png": 189,
	"./video-trim": 391,
	"./video-trim-active": 392,
	"./video-trim-active.svg": 392,
	"./video-trim.svg": 391,
	"./view-grid": 393,
	"./view-grid-active": 394,
	"./view-grid-active.svg": 394,
	"./view-grid.svg": 393,
	"./view-list": 395,
	"./view-list-active": 396,
	"./view-list-active.svg": 396,
	"./view-list.svg": 395,
	"./windows": 397,
	"./windows.svg": 397,
	"./your_plan_badge@2x": 190,
	"./your_plan_badge@2x.png": 190,
	"./zendesk": 191,
	"./zendesk.png": 191
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 493;